export function OAuthDivider() {
  return (
    <div className="flex justify-center my-3">
      <span className="text-xs uppercase text-muted-foreground">or</span>
    </div>
  );
}
